module.exports = __webpack_public_path__ + "img/avatar6.7df56ead.png";